export default __webpack_public_path__ + "static/media/company.9da4abdb.svg";